module.exports = __webpack_public_path__ + "static/media/Mask Group 156.54cad2f5.png";